import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SxProps } from '@mui/system'
import { Stack, Typography } from '@vapor/material'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import { HiCIcon } from '../icons/icon'

type HICTitleProps = {
  title: string
  titleEnd?: JSX.Element
  description?: string
  faIcon?: IconProp
  sx?: SxProps | undefined
  removeMargin?: true
}

/**
 * Responsive Title
 */
export const HICTitle = (props: HICTitleProps) => {
  const { title, titleEnd, description, faIcon, sx, removeMargin } = props

  const { sm } = useBreakpoints()

  return (
    <Stack direction="row" spacing={{ xs: 0, sm: 1 }} display="flex" alignItems="center" marginBottom={removeMargin ? undefined : 1} sx={sx}>
      <HiCIcon sx={{ display: { xs: 'none', sm: 'initial' } }}>
        {faIcon ? ( //
          <FontAwesomeIcon icon={faIcon} />
        ) : undefined}
      </HiCIcon>
      <Stack>
        <Stack direction="row">
          <Typography variant={sm ? 'titleSmall' : 'titleXSmall'}>{title}</Typography>
          {titleEnd}
        </Stack>
        {description ? ( //
          <Typography variant={'caption'}>{description}</Typography>
        ) : undefined}
      </Stack>
    </Stack>
  )
}
